import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/blog3.png";
import { Link } from "react-router-dom";
import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";
const Chatbot: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
               Intelligent conversations that enhance every customer interaction.
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
               At our AI SaaS and data solutions company, we design AI powered chatbots and virtual assistants that transform how businesses communicate with their customers. These systems go beyond scripted responses using natural language understanding to engage in meaningful, human like conversations.
              </p>

              <p className="mt-20">
              Our virtual assistants are built to handle high volumes of interactions while maintaining accuracy, consistency, and context. From answering customer queries and resolving common issues to guiding users through processes, our AI chatbots improve response times, reduce support costs, and elevate customer satisfaction.
              </p>
              <p className="mt-20">
            We take a client centered approach, ensuring each chatbot is tailored to your business needs, industry, and customer journey. By integrating AI assistants into existing platforms, we help businesses deliver seamless, always-on support that scales effortlessly.
              </p>

              {/* VIDEO EMBED */}
              <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
                  <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/M2C-yFocLu0?si=Y0dlxZQUpQ3TIxFi" title="YouTube video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Natural Language Understanding (NLU).</span></li>
                    <li><span className="iconlist_text">24/7 Intelligent Support.</span></li>
                    <li><span className="iconlist_text">Multi-Channel Deployment.</span></li>
                    <li><span className="iconlist_text">Context-Aware Conversations.</span></li>
                    <li><span className="iconlist_text">Seamless System Integration.</span></li>
                    <li><span className="iconlist_text">Continuous Learning & Improvement.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-20 mt-60">
               Redefining Customer Experience with Conversational AI
              </h3>

              <p className="mb-40">
               AI chatbots and virtual assistants continuously learn from interactions, enabling them to understand intent, adapt responses, and improve over time. Unlike traditional support tools, conversational AI evolves with customer behavior, delivering more relevant and accurate engagement.<br></br>
                By combining natural language processing, machine learning, and real-time data access, our solutions empower businesses to provide proactive, personalized customer experiences across digital touchpoints.
              </p>

              <h3 className="item_details_info_heading mb-25">3 Ways AI Chatbots Transform Customer Engagement</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Faster Response Times.</span></li>
                <li><span className="iconlist_text">2. Cost-Effective Support Operations.</span></li>
                <li><span className="iconlist_text">3. Consistent, Personalized Experiences.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default Chatbot;
